import { userContext } from "src/context/userContext";
import SiteAppBarLoggedInLayout from "./layout/SiteAppBarLoggedInLayout";
import SiteAppBarAnonLayout from "./layout/SiteAppBarAnonLayout";
import { AppBar } from "@mui/material";
import TitleAndLogo from "./components/TitleAndLogo";
import LazyLoader from "../Progress/LazyLoader";
import { lazy, useContext } from "react";
const SiteAppBarNotificationsIcon = lazy(() =>
  import("src/components/comms/NotificationsIcon/MyNotificationsIcon")
);

export default function SiteAppBarLayout() {
  const { isLoggedIn } = useContext(userContext) || {};
  return (
    <div className="noPrint" style={{ width: "100%" }}>
      <AppBar position="static" color="secondary" style={{ paddingTop: 6 }}>
        {/* <Toolbar> */}
        <div className="spaceBetween">
          <TitleAndLogo />
          <div className="center">
            <LazyLoader>
              <SiteAppBarNotificationsIcon />
            </LazyLoader>
            {isLoggedIn ? <SiteAppBarLoggedInLayout /> : <SiteAppBarAnonLayout />}
          </div>
        </div>
        {/* </Toolbar> */}
      </AppBar>
    </div>
  );
}
